// ── Termékoldal: „pont ezt a darabot kapod” – bizonyíték-sorok ─────────────
//
// Csak MEGLÉVŐ adatból épít (fotó, IMEI utolsó 4 jegye, mért akku). Amihez
// nincs adat, az az elem KIMARAD – nem írunk olyat, amit a készlet-API nem
// támaszt alá (pl. fotó nélkül nem mondjuk, hogy „ezt a darabot látod”).
// Bontatlan (új, gyári csomagolású) terméknél a fotó katalóguskép lehet, ezért
// ott egyik sor sem állít „konkrét darabot”.

/**
 * A fotó alatti sor elemei:
 *   „Ez a konkrét készülék · IMEI vége 4832 · Akku 92% (mért) · saját fotó”
 * @returns {string[] | null}  null → a hívó a régi, Bontatlan-szöveget mutatja
 */
export const konkretKeszulekElemek = ({ uid, battery, image } = {}, gradeKey = null) => {
  if (gradeKey === 'BONTATLAN') return null;
  return [
    'Ez a konkrét készülék',
    uid ? `IMEI vége ${uid}` : null,
    battery ? `Akku ${battery} (mért)` : null,
    image ? 'saját fotó' : null,
  ].filter(Boolean);
};

/**
 * Az ár alatti mikrosor (jóváhagyott szöveg, 2026-09-30):
 *   „Ezt a darabot látod a fotón · akku bevizsgálva · 3 hó szervizgarancia · számlával"
 *   „Átvétel előtt a boltban kipróbálhatod!”
 * A garancia- és számla-elem feltétel nélküli (a korábbi sor is az volt).
 */
export const arMikrosorElemek = ({ battery, image } = {}, gradeKey = null) => [
  image && gradeKey !== 'BONTATLAN' ? 'Ezt a darabot látod a fotón' : null,
  battery ? 'akku bevizsgálva' : null,
  '3 hó szervizgarancia',
  'számlával',
].filter(Boolean).map((e, i) => (i === 0 ? e.charAt(0).toUpperCase() + e.slice(1) : e));

export const AR_MIKROSOR_2 = 'Átvétel előtt a boltban kipróbálhatod!';
